import Analytics, { ACTION } from '../analytics/analytics';
import { METHOD, webRequest } from '../client/HttpClient';
import { API } from '../client/RouteConstants';

export const sendNotificationEmail = async (
    email: string,
    skuId: string,
    productId: string,
): Promise<NotificationEmailResponse> => {
    let success = false;
    try {
        const uri = `${process.env.REACT_APP_NOTIFICATION_HOST}${API.NOTIFICATION_EMAIL}?email=${email}&skuId=${skuId}&productId=${productId}`;

        const res = await webRequest(uri, { method: METHOD.POST }, false);

        if (res && res.ok) {
            Analytics.setProductIdOnJLData(productId);
            Analytics.dispatchAdobeAnalytics(ACTION.EMWBIS_SUBMITTED);
            success = true;
        }
    } catch {
        // silently swallow
    }

    return {
        success,
    };
};

interface NotificationEmailResponse {
    success: boolean;
}
